module.exports = __webpack_public_path__ + "img/0Q3A5798_L_Black.621b0e65.jpg";